import {Injectable} from '@angular/core';
import {NGXLogger} from 'ngx-logger';

@Injectable()
export class LoggerService {

  public static readonly LOGGER_FUNCTIONS = ['debug', 'error', 'info', 'log', 'trace', 'warn'];

  constructor(private real_logger: NGXLogger) {
    let guard = false; //guard for recursive console functions calling
    for (let m in this.real_logger) {
      if (typeof this.real_logger[m] === 'function' && LoggerService.LOGGER_FUNCTIONS.indexOf(m) > -1) {
        //this[m] = this.real_logger[m].bind(this.real_logger);

        let oldFunct = window.console[m];
        this[m] = window.console[m] = (...args: any[]) => {
          if (!guard) {
            guard = true;
            this.real_logger[m].apply(this.real_logger, args);
            guard = false;
          } else {
            oldFunct.apply(window.console, args);
          }
        };
      }
    }

    // for (let m in window.console) {
    //   if (typeof window.console[m] === 'function' && LoggerService.LOGGER_FUNCTIONS.indexOf(m) > -1) {
    //     let funcName = m;
    //     let oldFunc = window.console[funcName];
    //     if (_logger.SEND_LOGS_TO_SERVER) {
    //       this[funcName] = (...optionalParams: any[]) => {
    //         this._log(funcName.toUpperCase(), optionalParams);
    //         oldFunc.apply(window.console, ['[' + funcName.toUpperCase() + ']'].concat(optionalParams));
    //       }
    //     } else {
    //       this[funcName] = oldFunc.bind(window.console, '[' + funcName.toUpperCase() + ']');
    //     }
    //     window.console[funcName] = this[funcName];
    //   }
    // }
  }

  // WARN: do not add code to following functions, they are dummy and replace by real implementation of console object in the constructor.
  trace(message: any, ...additional: any[]): void {
  }

  debug(message: any, ...additional: any[]): void {
  }

  info(message: any, ...additional: any[]): void {
  }

  log(message: any, ...additional: any[]): void {
  }

  warn(message: any, ...additional: any[]): void {
  }

  error(message: any, ...additional: any[]): void {
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/core/logger/logger.service.ts